import React, { Component } from 'react';
import { connect } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { fetchAccionesLiquidaciones } from '../../../../actions/LiquidacionesActions';
import { fetchListaConceptos } from '../../../../actions/tiposActions';
import { putEliminaConceptoFinal, putEditaConceptoFinal } from '../../../../api/axios';
import { EstiloCombos, DropDownArrow } from '../../../../template/CustomStyle';
import Select from 'react-select';
import { toast } from 'react-toastify';
import { OverlayTrigger, Popover } from 'react-bootstrap';
import { Spinner } from 'react-bootstrap';

// Wrapper para usar hooks en class component
function ListConceptosWrapper(props) {
  const navigate = useNavigate();
  return <ListConceptos {...props} navigate={navigate} />;
}

class ListConceptos extends Component {
    constructor(props) {
        super(props);
        this.state = {
            descripcion: "",
            dropdownSubTipo: {
                idSubTipo: null,
                label: ""
            }
        }
    };

    componentDidMount() {
        this.props.fetchAccionesLiquidaciones();
        this.props.fetchListaConceptos();
    }

    loadInputs(tipoConcepto) {

        const { detalleConcepto, idSubTipo, descripcionSubTipoNovedad } = tipoConcepto;

        this.setState({ 
            descripcion: detalleConcepto,
            dropdownSubTipo: { 
                ...this.state.dropdownSubTipo, 
                idSubTipo: idSubTipo,
                label: descripcionSubTipoNovedad
            }
        });
    }

    myChangeHandler = async (e) => {
        const { name, value } = e.target;
        this.setState({ [name]: value });
    }

    onChangeDropdownSubTipo = async (e) => {

        const { label, value } = e;

        this.setState({ 
            dropdownSubTipo: { 
                ...this.state.dropdownSubTipo, 
                idSubTipo: value,
                label: label
            } 
        });
    }

    editarConcepto = (idConcepto) => {
        const { descripcion, dropdownSubTipo } = this.state;

        let datos = {
            idConcepto: idConcepto,
            idTipoNovedad: dropdownSubTipo.idSubTipo,
            descripcionConcepto: descripcion
        }
        let post = putEditaConceptoFinal(datos);

        post.then(res => {
            this.componentDidMount();
            document.getElementById("title").click();
            toast.success("El concepto fue actualizado con exito");
        }).catch(err => {
            toast.error("No pudimos editar el concepto");
        });
    }

    eliminarConcepto = (idTipoNovedad) => {

        let data = {
            IdTipoNovedad: idTipoNovedad
        };

        let post = putEliminaConceptoFinal(data);

        post.then(res => {
            toast.success(res.data.conceptoAnulado);
            this.componentDidMount();
        }).catch(err => {
            toast.error("No se pudo eliminar el concepto");
        });
    }

    gotoNuevoConcepto = () => {
        this.props.navigate("/Conceptos/Nuevo");
    }

    render() {
        const { lista_acciones_liquidaciones, loadingTipos } = this.props;
        const { descripcion, dropdownSubTipo } = this.state;
        let tiposConceptos = !Array.isArray(this.props.tiposConceptos) ? [] : this.props.tiposConceptos;

        let listaAccionesLiquidacion = [];
        if (lista_acciones_liquidaciones !== undefined) {
            listaAccionesLiquidacion = lista_acciones_liquidaciones.map((tipo) => ({
                label: tipo.descripcion,
                value: tipo.idEstado,
            }));
        }

        return (
            <div className="container">

                <div className="row justify-content-between mb-3">
                        
                    <div className="col-12 col-md-7">
                        <h4 className="text-themecolor color-rojo-megatone">Gestión de Conceptos</h4>
                    </div>

                    <div className="col-12 col-md-3 text-end">
                        <button 
                            type="button" 
                            onClick={this.gotoNuevoConcepto} 
                            className="btn btn-sm btn-green"
                        >
                            <i className="fa fa-plus-circle"/> Crear Concepto
                        </button>
                    </div>

                </div>

                {loadingTipos ? (
                    <div className="d-flex justify-content-center">
                        <Spinner animation="border" variant="secondary" size="lg-centrado" role="status">
                            <span className="sr-only">Loading...</span>
                        </Spinner>
                    </div>

                ) : tiposConceptos.length === 0 ? (
                
                    <div className="container">
                        <h5 className="d-flex justify-content-center m-t-40 m-b-40">
                            NO SE ENCONTRARON RESULTADOS
                        </h5>
                    </div>

                ) : (

                    <div className="list-group-item col-12 animated fadeIn">
                        <div className="table-responsive card">
                            <table className="table">
                                <thead>
                                    <tr>
                                        <th>Nombre</th>
                                        <th>Acción</th>
                                        <th>Editar</th>
                                    </tr>
                                </thead>
                                <tbody>
                                {
                                    tiposConceptos.map((tipoConcepto, i) => {
                                        return (
                                            <tr key={i} className="hover-background-color">
                                                <td><small>{tipoConcepto.idConcepto}</small></td>
                                                <td><small>{tipoConcepto.descripcionSubTipoNovedad}</small></td> 
                                                <td>
                                                {
                                                    tipoConcepto.mostrarBotonEliminar ?
                                                    <div key={i}>

                                                        <OverlayTrigger
                                                            key={`overlay-edit-${i}`}
                                                            trigger="click"
                                                            rootClose={true}
                                                            placement={"top"}
                                                            overlay={
                                                                <Popover id={`popover-edit-${i}`}>

                                                                    <Popover.Header className="text-center" as="h3">
                                                                        ¿Actualizar Concepto?
                                                                    </Popover.Header>
                                                                    
                                                                    <Popover.Body className="row justify-content-center align-items-center">

                                                                        <label className="col-4">Nombre:</label>

                                                                        <div className="col-8">
                                                                            <input 
                                                                                type="text" 
                                                                                name="descripcion"
                                                                                className="form-control" 
                                                                                value={descripcion}
                                                                                onChange={this.myChangeHandler} 
                                                                                maxLength="50"
                                                                            />
                                                                        </div>

                                                                        <label className="col-4 mt-2">Acción:</label>

                                                                        <div className="col-8 mt-2">
                                                                            <Select 
                                                                                className="text-capitalize"
                                                                                styles={EstiloCombos}
                                                                                options={listaAccionesLiquidacion}
                                                                                components={{ DropdownIndicator: () => DropDownArrow }}
                                                                                onChange={this.onChangeDropdownSubTipo}
                                                                                value={{
                                                                                    value: dropdownSubTipo.idSubTipo,
                                                                                    label: dropdownSubTipo.label
                                                                                }}
                                                                            />
                                                                        </div>

                                                                        <div className="mt-3 col-auto">
                                                                            <button 
                                                                                onClick={() => this.editarConcepto(tipoConcepto.idConcepto)}
                                                                                className="btn btn-sm background-rojo-megatone"
                                                                                disabled={descripcion === ""}
                                                                            >
                                                                                Actualizar
                                                                            </button>
                                                                        </div>

                                                                    </Popover.Body>
                                                                </Popover>
                                                            }
                                                        >
                                                            <button 
                                                                type="button" 
                                                                title="Editar" 
                                                                className="btn"
                                                                onClick={() => this.loadInputs(tipoConcepto)}
                                                            >
                                                                <i className="fa fa-clipboard" aria-hidden="true"/>
                                                            </button>
                                                        </OverlayTrigger>

                                                        <OverlayTrigger
                                                            key={`overlay-delete-${i}`}
                                                            trigger="click"
                                                            rootClose={true}
                                                            placement={"top"}
                                                            overlay={
                                                                <Popover id={`popover-delete-${i}`}>
                                                                    <Popover.Header as="h3">
                                                                        ¿Eliminar Concepto?
                                                                    </Popover.Header>
                                                                    <Popover.Body className="row justify-content-center">
                                                                        <button 
                                                                            className="btn btn-sm background-rojo-megatone col-auto"
                                                                            onClick={
                                                                                () => this.eliminarConcepto(tipoConcepto.idTipoNovedad)
                                                                            }
                                                                        >
                                                                            Eliminar
                                                                        </button>
                                                                    </Popover.Body>
                                                                </Popover>
                                                            }
                                                        >
                                                            <button 
                                                                title="Eliminar" 
                                                                type="button" 
                                                                className="btn color-rojo-megatone"
                                                            >
                                                                <i className="fa fa-trash" aria-hidden="true"/>
                                                            </button>
                                                        </OverlayTrigger>

                                                    </div>
                                                    : ""
                                                }
                                                </td>
                                            </tr>
                                        )
                                    })
                                }
                                </tbody>
                            </table>
                        </div>
                    </div>
                )}
            </div>
        );
    }
}


const mapStateToProps = state => ({
    tipoUsuario: state.general.tipoUsuario,
    loadingTipos: state.tipos.loadingTipos,
    tiposConceptos: state.tipos.tipoLiquidacionConcepto,
    lista_acciones_liquidaciones: state.liquidaciones.lista_acciones_liquidaciones
});

export default connect(mapStateToProps, { 
    fetchListaConceptos, 
    fetchAccionesLiquidaciones 
}) (ListConceptosWrapper);